import { render } from "./ItemTransferHistory.vue?vue&type=template&id=5782e37d&scoped=true"
import script from "./ItemTransferHistory.vue?vue&type=script&lang=js"
export * from "./ItemTransferHistory.vue?vue&type=script&lang=js"

import "./ItemTransferHistory.vue?vue&type=style&index=0&id=5782e37d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5782e37d"]])

export default __exports__